import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  House,
  Compass,
  Sparkle,
  ChatCircleDots,
  List,
} from "@phosphor-icons/react";

const tabs = [
  { to: "/", label: "Home", icon: House, end: true },
  { to: "/explore", label: "Compare", icon: Compass },
  { to: "/itinerary", label: "Plan", icon: Sparkle, primary: true },
  { to: "/experts", label: "Experts", icon: ChatCircleDots },
];

/**
 * Mobile-only fixed bottom tab bar — gives Flycher native-app feel on phones.
 * Hidden on >= md.
 * The "Menu" tab opens the existing hamburger drawer (Navbar's state),
 * so we toggle it via a window CustomEvent the Navbar listens to.
 */
export const MobileTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);

  // Hide tab bar on the admin pages and consultation page — they have their own chrome.
  useEffect(() => {
    setHidden(
      location.pathname.startsWith("/admin") ||
        location.pathname.startsWith("/consultation")
    );
  }, [location.pathname]);

  if (hidden) return null;

  const openMenu = () => {
    window.dispatchEvent(new CustomEvent("flycher:open-menu"));
  };

  return (
    <nav
      data-testid="mobile-tab-bar"
      className="md:hidden fixed bottom-0 left-0 right-0"
      style={{
        background: "rgba(255,255,255,0.92)",
        backdropFilter: "blur(20px) saturate(180%)",
        WebkitBackdropFilter: "blur(20px) saturate(180%)",
        borderTop: "1px solid rgba(11,37,69,0.08)",
        boxShadow: "0 -4px 24px -8px rgba(11,37,69,0.10)",
        paddingBottom: "env(safe-area-inset-bottom)",
        zIndex: 10000,
      }}
    >
      <div className="grid grid-cols-5 h-[64px]">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.end}
            data-testid={`mobile-tab-${t.label.toLowerCase()}`}
            onClick={(e) => {
              if (t.primary) {
                // tactile feel
                navigator.vibrate?.(10);
              }
            }}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[10px] font-medium transition-colors ${
                t.primary
                  ? ""
                  : isActive
                    ? "text-[#2A7FB8]"
                    : "text-slate-500"
              }`
            }
          >
            {t.primary ? (
              <span
                className="w-12 h-12 -mt-5 rounded-full grid place-items-center shadow-lg shadow-orange-300/40"
                style={{ background: "#FF7E4D", color: "#fff" }}
              >
                <t.icon size={22} weight="fill" />
              </span>
            ) : (
              <t.icon
                size={22}
                weight={location.pathname === t.to || (t.end && location.pathname === "/") ? "fill" : "regular"}
              />
            )}
            <span
              className={`${t.primary ? "text-[#FF7E4D] font-semibold" : ""} tracking-wide uppercase text-[10px]`}
            >
              {t.label}
            </span>
          </NavLink>
        ))}
        <button
          type="button"
          onClick={openMenu}
          data-testid="mobile-tab-menu"
          className="flex flex-col items-center justify-center gap-1 text-[10px] text-slate-500 hover:text-slate-800 transition-colors"
        >
          <List size={22} weight="regular" />
          <span className="tracking-wide uppercase text-[10px]">Menu</span>
        </button>
      </div>
    </nav>
  );
};
